import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createRule, deleteRule, listRules, updateRule } from '../api/rules';

const key = ['rules'] as const;

export function useRules() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: key, queryFn: listRules });
  const invalidate = () => qc.invalidateQueries({ queryKey: key });

  const create = useMutation({ mutationFn: createRule, onSuccess: invalidate });
  const update = useMutation({
    mutationFn: (args: { id: string; body: { pattern?: string; categorySlug?: string } }) =>
      updateRule(args.id, args.body),
    onSuccess: invalidate,
  });
  const remove = useMutation({ mutationFn: deleteRule, onSuccess: invalidate });

  return { rules: data ?? [], isLoading, actions: { create, update, remove } };
}
